import { useAppContext } from "../context/appContext"
import { HiChevronDoubleDown, HiChevronDoubleUp } from 'react-icons/hi'
import Wrapper from "../assets/wrappers/PageBtnContainer"
import { useState } from 'react';

const PageBtnContainer = () => {
    const {
        yearToDisplay,
        changeYearToDisplay,
        rowToDisplay,
        changeRowToDisplay,
        informationItems
    } = useAppContext()

    const [isUnfolded, setIsUnfolded] = useState(false);

    const maxPagesInRow = 6

    var pages = Object.keys(informationItems).reverse();

    return (
        <Wrapper>
            {
                <div className="btn-and-drop-down-container">
                    <div
                        className="btn-container">
                        {
                            pages.map((yearOfPage, index) => {
                                yearOfPage = parseInt(yearOfPage)
                                if (
                                    (index >= rowToDisplay * maxPagesInRow
                                        && index < rowToDisplay * maxPagesInRow + maxPagesInRow)
                                    || (isUnfolded)
                                ) {
                                    return <button
                                        className={yearToDisplay === yearOfPage ? 'pageBtn active' : 'pageBtn'}
                                        key={yearOfPage}
                                        onClick={() => {
                                            changeYearToDisplay(yearOfPage)
                                            changeRowToDisplay(Math.floor(index / maxPagesInRow))
                                            setIsUnfolded(false)
                                        }}
                                        type="button">
                                        {yearOfPage}
                                    </button>
                                }
                            })
                        }
                    </div>
                    <button className="dropDownBtn"
                        onClick={() => { setIsUnfolded(!isUnfolded) }}
                    >
                        {isUnfolded ? <HiChevronDoubleUp /> : <HiChevronDoubleDown />}
                    </button>
                </div>
            }
        </Wrapper >
    )
}

export default PageBtnContainer